import { useTimeLeft } from '@sorare/core/src/hooks/useTimeLeft';

export const useItemExpired = (expirationDate: Date | null) => {
  const { isEnded } = useTimeLeft(expirationDate);

  return isEnded;
};
